import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const ApeLogoCircle = t0 => {
  const $ = _c(17);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = square ? 0 : 12;
  let t4;
  if ($[7] !== t3) {
    t4 = <rect fill="#0054FA" height={24} rx={t3} width={24} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="m8.215 7.702 1.031 8.573H7.891l-.15-1.865h-.72l-.15 1.865H5.585l1.031-8.573h1.6Zm-.822 2.329h-.035l-.105 1.483-.139 1.76h.533l-.15-1.76-.104-1.483Zm5.123-2.329c.984 0 1.587.58 1.587 1.622v2.108c0 1.032-.603 1.61-1.587 1.61h-.429v3.233h-1.379V7.702ZM12.4 8.733h-.301v3.279h.3c.232 0 .325-.209.325-.58V9.324c0-.382-.093-.59-.324-.59Zm3.29-1.031v8.573h2.689V15.14h-1.31v-2.63h1.17v-1.135h-1.17V8.837h1.31V7.702H15.69Z" fill="#FFF" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <g fill="none" fillRule="evenodd">{t4}{t5}</g>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== rest || $[14] !== t2 || $[15] !== t6) {
    t7 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[12] = className;
    $[13] = rest;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const ApeLogoCircleMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M24 12c0-6.634-5.38-12-12-12C5.366 0 0 5.366 0 12c0 6.62 5.366 12 12 12 6.62 0 12-5.38 12-12ZM8.215 7.702H6.616l-1.03 8.573H6.87l.15-1.865h.72l.15 1.865h1.355l-1.03-8.573Zm-1.1 5.573.138-1.761.105-1.483h.035l.104 1.483.15 1.76h-.533Zm3.593 3h1.379v-3.232h.429c.984 0 1.587-.58 1.587-1.61V9.323c0-1.043-.603-1.622-1.587-1.622h-1.808v8.573Zm1.692-4.263h-.301V8.733h.3c.232 0 .325.209.325.591v2.108c0 .371-.093.58-.324.58Zm3.29-4.31v8.573h2.689V15.14h-1.31v-2.63h1.17v-1.135h-1.17V8.837h1.31V7.702H15.69Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};